// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"d6888ea6","453":"e6446e43","456":"230fefd1","578":"d09d0ca0","846":"a3e770eb"}[chunkId] + ".chunk.js";
};